export interface PartnerConstant {
  name: string;
  slug: string;
}

export interface PartnerApp {
  PARTNER: PartnerConstant;
}

export const getPartnerConfig = () => {
  const app = window as unknown as PartnerApp;
  return app.PARTNER;
};
